import { $, $$ } from '@3pc/dom';
import { ClickRedirect } from '@3pc/click-redirect';

const teaserImages = $$('.image-teaser__item');

if (teaserImages.length) {
  teaserImages.forEach(teaserImage => {
    // Get references to the source and target elements
    const sourceElement = $('.image-teaser__picture', teaserImage);
    const targetElement = $('.image-teaser__link', teaserImage);

    // Define configuration options
    const config = {
      preventDefault: false, // Prevent the default click behavior
    };

    // Create a ClickRedirect instance
    const clickRedirect = new ClickRedirect(
      sourceElement,
      targetElement,
      config
    );

    // Activate the ClickRedirect (add event listeners)
    clickRedirect.activate();
  });
}
